const { getGeneralInfoReducer } = require('./getGeneralInfo');

const generalInfoRootReducer = {
  generalInfo: getGeneralInfoReducer,
};

export { generalInfoRootReducer };
